@if (content(); as c) {
  <div
    class="nav-slim flex items-center gap-[8px] ultrawide:gap-12 text-inverse ultrawide:py-4 ultrawide:pr-8"
    id="mach-core-header-nav-slim"
  >
    <div
      class="nav-slim__links flex items-center whitespace-nowrap"
      id="mach-core-header-nav-slim-links"
    >
      <div
        class="nav-slim__separator h-[24px] w-[2px] border-[1px] laptop:mx-[10px] ultrawide:mx-[18px] opacity-full hidden laptop:block border-neutral-1000"
        aria-hidden="true"
      ></div>
      <div
        [class]="
          'nav-slim__destination text-label-lg-semibold hidden laptop:block' +
          (vacationContent() ? '' : ' cursor-pointer')
        "
        [attr.tabindex]="vacationContent() ? null : '0'"
        (click)="vacationContent() ? null : onClick()"
        (keydown.enter)="vacationContent() ? null : onClick()"
        (keydown.space)="vacationContent() ? null : onClick()"
        [attr.role]="vacationContent() ? null : 'button'"
        [attr.aria-label]="
          vacationContent()
            ? null
            : 'Edit flight destination from ' +
              c.origin +
              ' to ' +
              c.destination
        "
        [attr.aria-expanded]="vacationContent() ? null : modifyButtonOpen"
        id="mach-core-header-nav-slim-destination"
      >
        {{ c.origin }} - {{ c.destination }}
      </div>
      <div
        class="nav-slim__separator h-[24px] w-[2px] border-[1px] laptop:mx-[10px] ultrawide:mx-[18px] opacity-full hidden laptop:block border-neutral-1000"
        aria-hidden="true"
      ></div>
      @if ($any(c).tripType) {
        <div
          class="nav-slim__trip-type text-body-sm cursor-pointer hidden laptop:block"
          tabindex="0"
          (click)="onClick()"
          (keydown.enter)="onClick()"
          (keydown.space)="onClick()"
          role="button"
          [attr.aria-label]="'Edit trip type: ' + $any(c).tripType"
          [attr.aria-expanded]="modifyButtonOpen"
          id="mach-core-header-nav-slim-triptype"
        >
          {{ $any(c).tripType }}
        </div>
        <div
          class="nav-slim__separator h-[24px] w-[2px] border-[1px] laptop:mx-[10px] ultrawide:mx-[18px] opacity-full hidden laptop:block border-neutral-1000"
          aria-hidden="true"
        ></div>
      }
      <div
        [class]="
          'nav-slim__dates text-body-sm ml-0' +
          (vacationContent() ? '' : ' cursor-pointer')
        "
        [attr.tabindex]="vacationContent() ? null : '0'"
        (click)="vacationContent() ? null : onClick()"
        (keydown.enter)="vacationContent() ? null : onClick()"
        (keydown.space)="vacationContent() ? null : onClick()"
        [attr.role]="vacationContent() ? null : 'button'"
        [attr.aria-label]="
          vacationContent() ? null : 'Edit travel dates: ' + c.dates
        "
        [attr.aria-expanded]="vacationContent() ? null : modifyButtonOpen"
        id="mach-core-header-nav-slim-dates"
      >
        {{ c.dates }}
      </div>
      <div
        class="nav-slim__separator h-[24px] w-[2px] border-[1px] laptop:mx-[10px] ultrawide:mx-[18px] opacity-full hidden laptop:block border-neutral-1000"
        aria-hidden="true"
      ></div>
      <div
        [class]="
          'nav-slim__passenger text-body-sm hidden laptop:block' +
          (vacationContent() ? '' : ' cursor-pointer')
        "
        [attr.tabindex]="vacationContent() ? null : '0'"
        (click)="vacationContent() ? null : onClick()"
        (keydown.enter)="vacationContent() ? null : onClick()"
        (keydown.space)="vacationContent() ? null : onClick()"
        [attr.role]="vacationContent() ? null : 'button'"
        [attr.aria-label]="
          vacationContent() ? null : 'Edit passenger count: ' + c.passenger
        "
        [attr.aria-expanded]="vacationContent() ? null : modifyButtonOpen"
        id="mach-core-header-nav-slim-passenger"
      >
        {{ c.passenger }}
      </div>
      <div
        class="nav-slim__separator h-[24px] w-[2px] border-[1px] opacity-full hidden tablet:block tablet:mx-8 laptop:mx-[10px] ultrawide:mx-[18px] border-neutral-1000"
        aria-hidden="true"
      ></div>
    </div>
    <button
      class="nav-slim__modify button button-sm flex items-center text-label-xs-semibold border-[2px] border-stroke-03 rounded-[4px]"
      [attr.aria-label]="'Modify flight search: ' + c.modifyButton"
      [attr.aria-expanded]="modifyButtonOpen"
      (click)="onClick()"
      id="mach-core-header-nav-slim-modify"
    >
      {{ c.modifyButton }}
      <div
        class="nav-slim__modify--image nav-slim__modify--image--{{
          modifyButtonOpen
        }} w-4"
        aria-hidden="true"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          [class.rotate-180]="modifyButtonOpen"
          class="transition-transform"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 9L0.75 3H11.25L6 9Z"
            fill="white"
          />
        </svg>
      </div>
    </button>
  </div>
}
